import { render } from "./OrderItem.vue?vue&type=template&id=18838625&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=ts"
export * from "./OrderItem.vue?vue&type=script&lang=ts"

import "./OrderItem.vue?vue&type=style&index=0&id=18838625&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18838625"

export default script